<template>
  <div v-if="visible">
    <div class="gc_mask" />
    <div class="modal-wrap">
      <div class="modal modal-transparent">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-close" @click="goClose" />
          </div>
          <div class="modal-body">
            下载名厨App
          </div>
          <div class="modal-footer">
            <div class="modal-button-group-v modal-button-group-normal">
              <a class="modal-button" role="button" @click="goClose">下载</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  articles
} from '@/api/api'
export default {
  props: {
    downShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.downShow
    }
  },
  watch: {
    downShow(val) {
      this.visible = val
    }
  },
  methods: {
    goClose() {
      this.visible = false
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      const pid = isAndroid ? 1 : 2
      articles.version(pid).then(res => {
        window.location.href = res.data.url
      })
      this.$emit('showDwon', this.visible)
    }
  }
}
</script>
